import { render } from "./containerItem.vue?vue&type=template&id=f2df2e90&scoped=true"
import script from "./containerItem.vue?vue&type=script&lang=ts"
export * from "./containerItem.vue?vue&type=script&lang=ts"

import "./containerItem.vue?vue&type=style&index=0&id=f2df2e90&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f2df2e90"

export default script